import React, { ComponentProps } from 'react'

import { FlexBox } from './FlexBox'

export const List = (props: ComponentProps<typeof FlexBox>) => (
  <FlexBox {...{ fd: 'column', role: 'list', ...props }} />
)
